import { Typography } from '@mui/material';
import { Column, RightDrawer, Spacer } from '../../components';
import { logo3nUni } from '../../assets/png';
import { Svgs } from '../../assets/svg';
import { PricebookBundle } from '../../models/PricebookData';
import {
  CloseButton,
  DescriptionSection,
  LearnMoreDrawerHeader,
  LearnMoreSummaryCard,
  SvgBulletRow,
  YourLifeGoals,
} from './components';

export interface LearnMoreDrawerProps {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  pricebookBundle: PricebookBundle;
  freemium?: boolean;
}

export const LearnMoreAdviceAndThreeNickelsUDrawer: React.FC<LearnMoreDrawerProps> = ({
  drawerOpen,
  setDrawerOpen,
  pricebookBundle,
  freemium,
}) => {
  return (
    <RightDrawer open={drawerOpen} setOpen={setDrawerOpen}>
      <LearnMoreDrawerHeader
        paidBy={pricebookBundle.pricebook.paidBy}
        pricebookName={pricebookBundle.pricebook.pricebookName}
        logo={logo3nUni}
      />

      <LearnMoreSummaryCard pricebookBundle={pricebookBundle} freemium={freemium} />
      <Spacer height='xs' />

      <DescriptionSection
        description={`You don’t have to choose to pay off debt OR save OR invest. 3Nickels helps you optimize
            all your goals as one integrated plan.`}
        art={<Svgs.ArtStudyMaterials style={{ marginLeft: '20px', marginRight: '20px' }} />}
      />

      <Spacer height='xs' />
      <Typography color='secondary' variant='p18SemiBold'>
        At a glance...
      </Typography>

      <Column style={{ padding: '0px 10px', rowGap: '20px', marginTop: '20px' }}>
        <SvgBulletRow
          art={<Svgs.Bullet3nUniCoach />}
          text={`Personalized one-on-one `}
          boldPostText='coaching'
        />
        {freemium ? (
          <SvgBulletRow art={<Svgs.BulletPiggyBank />} text={`Budget `} boldPostText='planner' />
        ) : (
          <SvgBulletRow
            art={<Svgs.BulletInvestment />}
            text={`Objective `}
            boldPostText='investment advice'
          />
        )}
        <SvgBulletRow art={<Svgs.BulletCalculator />} text={`Customizable `} boldPostText='tools' />
        <SvgBulletRow
          art={<Svgs.Bullet3nUniLessons />}
          text={`Interactive `}
          boldPostText='courses'
        />
      </Column>

      <YourLifeGoals />

      <CloseButton setDrawerOpen={setDrawerOpen} />
    </RightDrawer>
  );
};
